<template>
  <SmartHrLocalList module-type="RETIRE" title="退休管理" group-name="员工关系"/>
</template>
<script>
import SmartHrLocalList from './SmartHrLocalList'
export default {
  name: 'SmartHrRetire',
  components: { SmartHrLocalList }
}
</script>



// WEBPACK FOOTER //
// SmartHrRetire.vue?1254d7aa